module.exports = __webpack_public_path__ + "static/media/pc.c5732a2b.svg";